export const CAT_LANGUAGE = 'ca';
export const WAIT_INITIALIZATION = 500;
